class productSelectOption extends HTMLElement {
  constructor() {
    super();
    this.selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
  }

  connectedCallback() {
    this.initSwiper();
    this.addEventListeners();
    this.addMoreOption();
    localStorage.removeItem("dataMoreProduct");
  }

  initSwiper() {
    new Swiper('.rocket-select-option__container', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      mousewheel: {
        forceToAxis: true
      }
    });
  }

  addEventListeners() {
    this.querySelectorAll(".card-select_option-change").forEach((selectOption) => {
      selectOption.addEventListener("click", (event) => {
        event.stopPropagation();
        document.body.classList.add('overflow-hidden');
  
        const popupContainer = selectOption.closest('.rocket-select-option__item').querySelector('.rocket-select-option__item-popup');
        const closePopupBtn = popupContainer.querySelector('.rocket-select-option__item-popup-close');
        const optionContainers = document.querySelectorAll('.rocket-select-option__item-container');
  
        if (!popupContainer.dataset.originalParent) {
          popupContainer.originalParent = popupContainer.parentNode;
          popupContainer.originalNextSibling = popupContainer.nextElementSibling;
        }
  
        document.body.appendChild(popupContainer);
        popupContainer.classList.remove('hidden');
        popupContainer.querySelector('.product-form').classList.add('active');
        optionContainers.forEach(optionContainer => {
          optionContainer.classList.remove('option-product-active');
        })
        selectOption.closest('.rocket-select-option__item-container').classList.add('option-product-active');
  
        closePopupBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          this.closePopup(popupContainer);
        });
      });
    });
  
    document.addEventListener("click", (event) => {
      document.querySelectorAll(".rocket-select-option__item-popup").forEach((popup) => {
        if (!popup.contains(event.target)) {
          this.closePopup(popup);
        }
      });
    });
  
  }
  
  closePopup(popup) {
    document.body.classList.remove('overflow-hidden');
    popup.classList.add("hidden");
    if (popup.originalParent) {
      if (popup.originalNextSibling) {
        popup.originalParent.insertBefore(popup, popup.originalNextSibling);
      } else {
        popup.originalParent.appendChild(popup);
      }
    }
  }

  addMoreOption() { 
    const submitMoreOptions = document.querySelectorAll('.rocket-select-option__item-popup .confirm-size');
    const selectSizes = document.querySelectorAll('.rocket-select-option__item-popup-product-info .product-form');
    submitMoreOptions.forEach((submitMoreOption)=> {
      submitMoreOption.addEventListener('click', ()=> {
        const containerInfo = submitMoreOption.closest('.rocket-select-option__item-popup-product-info');
        const popupContainer = submitMoreOption.closest('.rocket-select-option__item-popup');
        const variantForms = containerInfo.querySelectorAll('.product-form');
        let dataMoreProduct = []; 
        variantForms.forEach(variantForm => {
          if(variantForm.classList.contains('active')) {            
            const productId = variantForm.querySelector('input[name="product-id"]').value;
            const variantID = variantForm.querySelector('.product-form__submit input').value;
            dataMoreProduct.push({ productId, variantID });
            variantForm.querySelector('.product-form__submit').click();
          }
        });
        localStorage.setItem("dataMoreProduct", JSON.stringify(dataMoreProduct));
        this.closePopup(popupContainer);
      })
    });
    selectSizes.forEach(selectSize => {
      selectSize.addEventListener('click', () => {
        const variantForms = document.querySelectorAll('.product-form');
        variantForms.forEach(variantForm => {
          variantForm.classList.remove('active');
        });
        selectSize.classList.add('active');
      })
    })
  }
  
}

customElements.define('rocket-select-option', productSelectOption);